import type { TipTapDoc, TipTapNode } from "../schema/tiptapDoc";

const BLOCK_TYPES = new Set([
    "paragraph",
    "heading",
    "blockquote",
    "listItem",
    "tableCell",
    "tableHeader",
    "horizontalRule",
]);

function walk(node: TipTapNode, parts: string[]): void {
    switch (node.type) {
        case "text":
            parts.push(node.text);
            return;
        case "hardBreak":
            parts.push("\n");
            return;
        case "image":
            if (node.attrs.alt) parts.push(`[image: ${node.attrs.alt}]`);
            else parts.push(`[image]`);
            parts.push("\n\n");
            return;
        case "mediaEmbed":
            parts.push(`[${node.attrs.kind} embed: ${node.attrs.url}]`);
            parts.push("\n\n");
            return;
        case "horizontalRule":
            parts.push("\n\n");
            return;
        default: {
            // Block-level / list / table containers — recurse, then add a
            // separator so flattened text reads sensibly.
            const content = "content" in node ? node.content : undefined;
            if (content) {
                for (const child of content) {
                    walk(child, parts);
                }
            }
            if (BLOCK_TYPES.has(node.type)) {
                parts.push("\n\n");
            }
        }
    }
}

export function getPlainTextFromDoc(doc: TipTapDoc | null | undefined): string {
    if (!doc || doc.type !== "doc" || !Array.isArray(doc.content)) return "";
    const parts: string[] = [];
    for (const child of doc.content) {
        walk(child, parts);
    }
    return parts
        .join("")
        .replace(/\n{3,}/g, "\n\n")
        .trim();
}
